export const fnbRoutes = {
  kitchenSelect: 'client.fnb-order-queue.dashboard',
  orderQueue: 'client.fnb-order-queue',
  orderHistory: 'client.fnb-order-queue.order-history',
  orderList: 'client.fnb-order-queue.order-list',
  orderDetails: 'client.fnb-order-queue.order-details',
  orderRefund: 'client.fnb-order-queue.order-refund',
};
